// extracted by mini-css-extract-plugin
export default {"formItemMenu":"styles_formItemMenu__LJ3IX","action":"styles_action__YtRrh","menuIcon":"styles_menuIcon__SEZXx"};